import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Spacer,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Input,
  Checkbox,
  Notify,
} from '@flexisaf/flexibull2';
import PropTypes from 'prop-types';
import Theme from 'utils/theme';
import request from 'utils/request';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export default function EditRefereeModal({
  open,
  referee,
  onClose,
  onSuccess,
}) {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [sendNotification, setSendNotification] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (referee) {
      setEmail(referee.email || '');
      setName(referee.name || '');
      setPhone(referee.phone || '');
    }
  }, [referee]);

  const handleSubmit = async () => {
    if (!referee?.id || !email?.trim()) return;
    setSubmitting(true);
    const url = `${API_BASE_URL}/candidates/referees/${referee.id}`;
    const response = await request({
      method: 'patch',
      url,
      data: {
        email: email.trim(),
        name: name?.trim() || undefined,
        phone: phone?.trim() || undefined,
        sendNotification,
      },
    });
    setSubmitting(false);
    if (response.success) {
      Notify('Referee updated successfully', {
        position: 'top-right',
        status: 'success',
      });
      onClose();
      if (onSuccess) onSuccess();
    } else {
      networkErrorHandler(response?.statusCode, response?.message);
    }
  };

  return (
    <Modal open={open}>
      <ModalBody width="500px">
        <Box pad="30px 30px 0">
          <Text block size="25px">
            Edit referee
          </Text>
          <Spacer space="20px" />
          <Input
            type="email"
            label="Email"
            placeholder="Referee email"
            value={email}
            onChange={({ target: { value } }) => setEmail(value)}
            block
            required
          />
          <Spacer space="15px" />
          <Input
            type="text"
            label="Name"
            placeholder="Referee name"
            value={name}
            onChange={({ target: { value } }) => setName(value)}
            block
          />
          <Spacer space="15px" />
          <Input
            type="text"
            label="Phone"
            placeholder="Referee phone"
            value={phone}
            onChange={({ target: { value } }) => setPhone(value)}
            block
          />
          <Spacer space="20px" />
          <Checkbox
            label="Send notification to new email"
            checked={sendNotification}
            onChange={() => setSendNotification(!sendNotification)}
          />
        </Box>
        <ModalFooter>
          <Box align="right" pad="20px 40px">
            <Button
              pale
              color="transparent"
              fontColor={Theme.PrimaryGrey}
              iconLeft={<i className="flexibull-left" />}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              primary
              iconRight={<i className="saf-check" />}
              disabled={!email?.trim()}
              progress={submitting}
              onClick={handleSubmit}
            >
              Save
            </Button>
          </Box>
        </ModalFooter>
      </ModalBody>
    </Modal>
  );
}

EditRefereeModal.propTypes = {
  open: PropTypes.bool,
  referee: PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    phone: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};
